export const HTTP_ERRORS = {
  timeout: "ETIMEOUT",
  connnectRefused: "ECONNREFUSED",
  serverError: "SEVERERROR",
  tokenError: "TOKENERROR",
  notFound: "NOTFOUND",
  loginError: "LOGINERROR",
  errorUserOrPassword: "ERRORUSERORPASSWORD",
  netError: "NETERROR"
};
export const LOGSTATES = {
  unlogined: "UNLOGINED",
  logging: "LOGGING",
  logined: "LOGGINED",
  falied: "FAILED"
};



// WEBPACK FOOTER //
// ./src/services/httpreq/const.js